module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.tabs), function(tab) {
    return [(_vm.milestonesForTab(tab.key).length) ? _c('div', {
      key: tab.key,
      staticClass: "heading"
    }, [_vm._v(_vm._s(tab.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.milestonesForTab(tab.key)), function(element) {
      return [(element.type != 'Section' && element.type != 'Tab') ? _c('div', {
        key: element.key,
        staticClass: "hoverable pa-1",
        staticStyle: {
          "display": "flex",
          "border-radius": "5px"
        },
        on: {
          "click": function($event) {
            return _vm.$emit('jump', element)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "padding-top": "5px"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": (element.value || element.complete ? 'green' : 'grey lighten-2'),
          "large": ""
        }
      }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('div', {
        staticClass: "grey--text text--darken-1",
        staticStyle: {
          "flex-grow": "1",
          "padding-top": "10px",
          "padding-left": "10px"
        }
      }, [_vm._v("\n                    " + _vm._s(element.title)), (element.value || element.complete) ? _c('div', {
        staticClass: "small-text",
        staticStyle: {
          "padding-top": "0",
          "padding-left": "0"
        }
      }, [_vm._v(_vm._s(_vm._f("stamp")(element.stamp)))]) : _vm._e()]), _vm._v(" "), _c('div', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('v-menu', {
        attrs: {
          "left": "",
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-btn', _vm._g({
              attrs: {
                "color": "grey",
                "text": "",
                "icon": ""
              }
            }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.complete(element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Complete")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.notApplicable(element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Not Applicable")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.$emit('jump', element)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Go Here")])], 1)], 1)], 1)], 1)]) : _vm._e()]
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7fa647"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionSummary.vue
// module id = 2570
// module chunks = 1